module.exports = __webpack_public_path__ + "img/hr-H-B-1-load-connect-shadow.e461c97d.png";